/**
 * Business Type Terminology Adapter
 * Provides context-aware labels based on vendor business type
 */

export const BUSINESS_TYPES = {
  RESTAURANT: 'restaurant',
  GROCERY: 'grocery',
  SERVICE: 'service'
};

export const getBusinessTypeConfig = (businessType = 'restaurant') => {
  const configs = {
    restaurant: {
      type: 'restaurant',
      label: 'Restaurant',
      itemLabel: 'Menu Item',
      itemsLabel: 'Menu Items',
      itemsShort: 'Items',
      catalogLabel: 'Menu',
      addItemLabel: 'Add Menu Item',
      orderLabel: 'Order',
      ordersLabel: 'Orders',
      customerLabel: 'Customer',
      customersLabel: 'Customers',
      icon: '🍽️',
      fields: {
        hasVariants: true,
        hasModifiers: true,
        hasPrepTime: true,
        hasDietaryTags: true,
        hasAppointments: false,
        hasDuration: false
      }
    },
    grocery: {
      type: 'grocery',
      label: 'Grocery Store',
      itemLabel: 'Product',
      itemsLabel: 'Products',
      itemsShort: 'Products',
      catalogLabel: 'Catalog',
      addItemLabel: 'Add Product',
      orderLabel: 'Order',
      ordersLabel: 'Orders',
      customerLabel: 'Customer',
      customersLabel: 'Customers',
      icon: '🛒',
      fields: {
        hasVariants: true,
        hasModifiers: false,
        hasPrepTime: false,
        hasDietaryTags: true,
        hasAppointments: false,
        hasDuration: false,
        hasSKU: true,
        hasStock: true,
        hasExpiryDate: true
      }
    },
    service: {
      type: 'service',
      label: 'Service Provider',
      itemLabel: 'Service',
      itemsLabel: 'Services',
      itemsShort: 'Services',
      catalogLabel: 'Services',
      addItemLabel: 'Add Service',
      orderLabel: 'Booking',
      ordersLabel: 'Bookings',
      customerLabel: 'Client',
      customersLabel: 'Clients',
      icon: '💼',
      fields: {
        hasVariants: false,
        hasModifiers: false,
        hasPrepTime: false,
        hasDietaryTags: false,
        hasAppointments: true,
        hasDuration: true,
        hasServiceArea: true
      }
    }
  };

  return configs[businessType] || configs.restaurant;
};

export default {
  BUSINESS_TYPES,
  getBusinessTypeConfig
};
